import isEmpty from "lodash/isEmpty.js";
import i18n from "@/i18n";

export class EntitySymptomValue {
  /**
   * @param {string} date
   * @param {EntitySymptomData} data
   */
  constructor(date, data) {
    let value = null;
    const hasValue = data.positive > 0;
    const hasEvents = !isEmpty(data.events);
    let list = [];

    if (hasValue) {
      value = {
        count: data.count,
        positive: data.positive,
        negative: data.count - data.positive,
      };

      list = [`Измерений сделано: ${data.count}`, `Было: ${value.positive}`, `Не было: ${value.negative}`];

      if (hasEvents && data.events.count > 1) {
        list.push(`Всего задача: ${data.events.count}`);
      }
    }

    this.date = date;
    this.eventsCount = hasEvents ? data.events.count : 0;
    this.value = value;
    this.list = list;
  }
}
